var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getAppDetail)?_c('div',[_c('detail-header',{attrs:{"page-name":"応募詳細"}}),_vm._v(" "),_c('detail-content')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }